import { render, staticRenderFns } from "./standard-modal.vue?vue&type=template&id=688d8462&"
import script from "./standard-modal.vue?vue&type=script&lang=js&"
export * from "./standard-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports